import { render, staticRenderFns } from "./StoryList2.vue?vue&type=template&id=487b34e0&scoped=true&"
import script from "./StoryList2.vue?vue&type=script&lang=js&"
export * from "./StoryList2.vue?vue&type=script&lang=js&"
import style0 from "./StoryList2.vue?vue&type=style&index=0&id=487b34e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487b34e0",
  null
  
)

export default component.exports